import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setMobileViewCookie, useWindowSetter } from '@beef/shop-common';
import { compose } from 'redux';
import { withMountListener } from '@beef/react';

import { PagePreloader } from 'bricks/PagePreloader';
import HeaderContainer from 'components/Header';
import FooterContainer from 'components/Footer';
import { ScrollTopButton } from 'bricks';
import { flocktoryService } from 'services';
import ABNotifier from 'components/Notifier';
import { getBasketLoading } from 'store/common/basket/selectors';
import { isFlocktoryEnabledSelector } from 'store/common/settings/selectors';
import { TradeInBanner } from 'components/TradeInBanner';
import { getBasketData } from 'store/common/basket/actions';
import { onLoadPageLayout } from 'store/common/page/actions';

import { Navigation } from './components/Navigation';
import { Seo } from '../../seo/index';

/**
 * Page wrapper that provides context passed in as 'data', and renders the view
 */
const PageLayout = (props) => {
  const {
    beforeContent,
    children,
    withNavigation,
    withTradeIn = true,
    isLoading,
    onlyCrumbs,
    isFlocktoryEnabled,
    getBasketDataRequest,
    header,
  } = props;

  const [setWindowFunc] = useWindowSetter({
    // eslint-disable-next-line no-unused-vars
    previewProduct: (slug) => {
      // eslint-disable-next-line no-console
      console.warn('can not open modal on this page');
    },
  });

  useEffect(() => {
    setWindowFunc();

    if (isFlocktoryEnabled) {
      flocktoryService.loadScript();
    }
  }, []);

  useEffect(() => {
    getBasketDataRequest();
  }, []);
  useEffect(() => {
    setMobileViewCookie();
  }, []);

  return (
    <>
      {header || <HeaderContainer />}
      {beforeContent}
      {withTradeIn && <TradeInBanner />}
      {withNavigation && <Navigation onlyCrumbs={onlyCrumbs} />}
      {children}
      <ScrollTopButton />
      <ABNotifier />
      <FooterContainer />
      {isLoading && <PagePreloader />}
      <Seo />
    </>
  );
};

PageLayout.propTypes = {
  beforeContent: PropTypes.node,
  children: PropTypes.node,
  onlyCrumbs: PropTypes.bool,
  isLoading: PropTypes.bool,
  withNavigation: PropTypes.bool,
  withTradeIn: PropTypes.bool,
  isFlocktoryEnabled: PropTypes.bool,
  getBasketDataRequest: PropTypes.func,
  header: PropTypes.node,
};

PageLayout.defaultProps = {
  withNavigation: true,
  isFlocktoryEnabled: false,
};

/** applies hot reload to entire page content */
const mapStateToProps = (state) => ({
  isLoading: getBasketLoading(state),
  isFlocktoryEnabled: isFlocktoryEnabledSelector(state),
});
const mapDispatchToProps = {
  getBasketDataRequest: getBasketData,
  onMount: onLoadPageLayout,
};
export default compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(PageLayout);
